import React from "react";
import { TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel";
  maxValue?: number;
}

const FormTextField: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, type, disabled, maxValue } =
    props;

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: {
          value: required!,
          message: "Required",
        },
        max: {
          value: maxValue!,
          message: `Value cannot be more than ${maxValue}`,
        },
      }}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          fullWidth
          label={label}
          helperText={error ? error.message : null}
          error={!!error}
          onChange={(e) => {
            const val = e.target.value;
            if (type === "number") {
              onChange(val === "" ? null : Number(val));
            } else {
              onChange(val);
            }
          }}
          value={
            type === "number"
              ? value ?? ""
              : value ?? ""
          }
          variant="outlined"
          type={type || "text"}
          disabled={disabled}
        />
      )}
    />
  );
};

export default FormTextField;
